import { CommonResponse } from '@xver/@types/api';
import httpClient from '@xver/libs/axios';
import { AddSSHKeyRequestModel, SSHKeyResponseModel } from './model';

const ENDPOINTS = {
    GET: '/v1/ssh-keys',
    ADD: '/v1/ssh-keys',
    DELETE: (id: number) => `/v1/ssh-keys/${id}`,
};

export function getSSHKeys(): Promise<SSHKeyResponseModel[]> {
    return httpClient.get(ENDPOINTS.GET);
}

export function addSSHKey(data: AddSSHKeyRequestModel): Promise<CommonResponse> {
    return httpClient.post(ENDPOINTS.ADD, data);
}

export function deleteSSHKey(id: number): Promise<CommonResponse> {
    return httpClient.delete(ENDPOINTS.DELETE(id));
}
